angular.module('ui.error', [])

    .config(function ($stateProvider) {
        $stateProvider.state('error', {
            url: '/error',
            templateUrl: 'app/ui/error/error.html',
            controller: 'ErrorController',
            data: { pageTitle: 'OrderManager: Error description' },
            resolve: {
                loadingWaiter: function () {
                    //hack that will hide loading screen, when main state is ready
                    if (window.omHideLoadingScreenCallback) {
                        window.omHideLoadingScreenCallback();
                    }
                }
            }
        });
    })

    .controller('ErrorController', function ErrorController($scope, $window, $interval, $localStorage) {
        $scope.appErrors = []; // collection of error messages
        var refreshPromise;

        $scope.clearErrors = function () {
            $scope.appErrors = [];
            $localStorage.setItem("errors", []);
        };

        $scope.refreshErrors = function () {
            try {
                $scope.appErrors = ($localStorage.getItem("errors") || []).slice().reverse();
            } catch (e) {
                if (refreshPromise) {
                    $interval.cancel(refreshPromise);
                }
                console.error("We were unable to refresh `/error` page", e);
            }
        };

        $scope.refreshErrors();
        refreshPromise = $interval($scope.refreshErrors, 1000);
    })
;